import { __decorate, __metadata } from "tslib";
import { IsUndefinable } from '@goparrot/common';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { IsBoolean, IsDefined, IsOptional, IsString, IsUrl, MaxLength, ValidateNested } from 'class-validator';
import { WebStoreExposeGroup } from '../interface';
import { ReadFaviconDto } from './ReadFaviconDto';
import { ReadProceedToCheckoutDto } from './ReadProceedToCheckoutDto';
import { ReadWebStoreMetadataCustomMessagesDto } from './ReadWebStoreMetadataCustomMessagesDto';
import { ReadWebStoreMetadataFooterDto } from './ReadWebStoreMetadataFooterDto';
import { ReadWebStoreMetadataThemeDto } from './ReadWebStoreMetadataThemeDto';
export class ReadWebStoreMetadataDto {
}
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    IsString({ always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataDto.prototype, "title", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    IsString({ always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataDto.prototype, "homeButtonUrl", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    IsString({ always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataDto.prototype, "headerLogo", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    IsString({ always: true }),
    IsUrl({ require_protocol: true, require_host: true, require_valid_protocol: true }, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataDto.prototype, "additionalLogo", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    IsString({ always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataDto.prototype, "gTag", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataDto.prototype, "gTags", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, default: false }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsBoolean({ always: true }),
    IsOptional({ always: true }),
    __metadata("design:type", Boolean)
], ReadWebStoreMetadataDto.prototype, "hideDesktopMenuItemImage", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, default: false }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsBoolean({ always: true }),
    IsOptional({ always: true }),
    __metadata("design:type", Boolean)
], ReadWebStoreMetadataDto.prototype, "hideMobileMenuItemImage", void 0);
__decorate([
    ApiProperty({ type: () => Boolean }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsBoolean({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", Boolean)
], ReadWebStoreMetadataDto.prototype, "hideInfoIcon", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    IsString({ always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataDto.prototype, "messangerLink", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    IsString({ always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataDto.prototype, "cartIcon", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    IsString({ always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataDto.prototype, "itemOptionSortStrategy", void 0);
__decorate([
    ApiProperty({ type: () => Boolean }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsBoolean({ always: true }),
    IsDefined({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", Boolean)
], ReadWebStoreMetadataDto.prototype, "showPreviousOrders", void 0);
__decorate([
    ApiProperty({ type: () => Boolean }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsBoolean({ always: true }),
    IsDefined({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", Boolean)
], ReadWebStoreMetadataDto.prototype, "showASAPOrderPreptime", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsBoolean({ always: true }),
    IsOptional({ always: true }),
    __metadata("design:type", Boolean)
], ReadWebStoreMetadataDto.prototype, "showOrderReminder", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    IsString({ always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataDto.prototype, "toastUrl", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    IsString({ always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataDto.prototype, "receiveMethodTitle", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    IsString({ always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataDto.prototype, "facebookPixel", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    IsString({ always: true }),
    MaxLength(250, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataDto.prototype, "facebookAccessToken", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    IsString({ always: true }),
    MaxLength(50, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataDto.prototype, "facebookTestCode", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", String)
], ReadWebStoreMetadataDto.prototype, "homeButtonText", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", String)
], ReadWebStoreMetadataDto.prototype, "serviceOptionsPageTitle", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", String)
], ReadWebStoreMetadataDto.prototype, "previousOrdersPageTitle", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", String)
], ReadWebStoreMetadataDto.prototype, "deliveryInstructionsTitle", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", String)
], ReadWebStoreMetadataDto.prototype, "deliveryInstructionsPlaceholder", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", String)
], ReadWebStoreMetadataDto.prototype, "taxTitle", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, default: false }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsUndefinable({ always: true }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], ReadWebStoreMetadataDto.prototype, "showZeroDeliveryFee", void 0);
__decorate([
    ApiProperty({ type: String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", String)
], ReadWebStoreMetadataDto.prototype, "topSellingItemsTitle", void 0);
__decorate([
    ApiProperty({ type: Boolean, default: false }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsBoolean({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", Boolean)
], ReadWebStoreMetadataDto.prototype, "showOrderNotes", void 0);
__decorate([
    ApiProperty({ type: Boolean, default: false }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsBoolean({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", Boolean)
], ReadWebStoreMetadataDto.prototype, "showDelayedPaymentDisclaimer", void 0);
__decorate([
    ApiProperty({ type: Boolean, default: false }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsBoolean({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", Boolean)
], ReadWebStoreMetadataDto.prototype, "isCurbsidePickupEnabled", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", String)
], ReadWebStoreMetadataDto.prototype, "curbsidePickupOrderNotesTitle", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsOptional({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", String)
], ReadWebStoreMetadataDto.prototype, "orderConfirmationPageTitle", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", String)
], ReadWebStoreMetadataDto.prototype, "editUserModalTitle", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", String)
], ReadWebStoreMetadataDto.prototype, "curbsidePickupOrderNotesPlaceholder", void 0);
__decorate([
    ApiProperty({ type: Boolean }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsBoolean({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", Boolean)
], ReadWebStoreMetadataDto.prototype, "showAsapInfoMessage", void 0);
__decorate([
    ApiProperty({ type: Boolean }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsBoolean({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", Boolean)
], ReadWebStoreMetadataDto.prototype, "forceShowAsapInfoMessage", void 0);
__decorate([
    ApiPropertyOptional({ type: Boolean }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], ReadWebStoreMetadataDto.prototype, "hideDelayedOrderTime", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, default: false }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], ReadWebStoreMetadataDto.prototype, "hidePromotionBar", void 0);
__decorate([
    ApiPropertyOptional({ type: Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataDto.prototype, "menu", void 0);
__decorate([
    ApiProperty({ type: Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsDefined({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataDto.prototype, "storeItem", void 0);
__decorate([
    ApiProperty({ type: Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsDefined({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataDto.prototype, "topCategories", void 0);
__decorate([
    ApiProperty({ type: Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsDefined({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataDto.prototype, "modifiers", void 0);
__decorate([
    ApiPropertyOptional({ type: Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataDto.prototype, "navigation", void 0);
__decorate([
    ApiProperty({ type: ReadWebStoreMetadataFooterDto }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsDefined({ groups: [WebStoreExposeGroup.UPDATE] }),
    ValidateNested({ always: true }),
    Type(() => ReadWebStoreMetadataFooterDto),
    IsUndefinable({ groups: [WebStoreExposeGroup.CREATE, WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", ReadWebStoreMetadataFooterDto)
], ReadWebStoreMetadataDto.prototype, "footer", void 0);
__decorate([
    ApiProperty({ type: ReadFaviconDto }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsDefined({ always: true }),
    ValidateNested({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    Type(() => ReadFaviconDto),
    __metadata("design:type", ReadFaviconDto)
], ReadWebStoreMetadataDto.prototype, "favicon", void 0);
__decorate([
    ApiProperty({ type: ReadWebStoreMetadataThemeDto }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsDefined({ always: true }),
    ValidateNested({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    Type(() => ReadWebStoreMetadataThemeDto),
    __metadata("design:type", ReadWebStoreMetadataThemeDto)
], ReadWebStoreMetadataDto.prototype, "theme", void 0);
__decorate([
    ApiProperty({ type: Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsDefined({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataDto.prototype, "itemModalConfig", void 0);
__decorate([
    ApiPropertyOptional({ type: Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataDto.prototype, "heroBlock", void 0);
__decorate([
    ApiPropertyOptional({ type: Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataDto.prototype, "receiveMethodPage", void 0);
__decorate([
    ApiPropertyOptional({ type: Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataDto.prototype, "disclaimers", void 0);
__decorate([
    ApiPropertyOptional({ type: Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataDto.prototype, "webstoreAddress", void 0);
__decorate([
    ApiPropertyOptional({ type: Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataDto.prototype, "promotionNotification", void 0);
__decorate([
    ApiPropertyOptional({ type: Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataDto.prototype, "cartPromotion", void 0);
__decorate([
    ApiProperty({ type: ReadWebStoreMetadataCustomMessagesDto }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsDefined({ always: true }),
    ValidateNested({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    Type(() => ReadWebStoreMetadataCustomMessagesDto),
    __metadata("design:type", ReadWebStoreMetadataCustomMessagesDto)
], ReadWebStoreMetadataDto.prototype, "customMessages", void 0);
__decorate([
    ApiPropertyOptional({ type: Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataDto.prototype, "customHeaderButton", void 0);
__decorate([
    ApiPropertyOptional({ type: Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataDto.prototype, "cartButton", void 0);
__decorate([
    ApiPropertyOptional({ type: Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataDto.prototype, "headerLogoUrl", void 0);
__decorate([
    ApiPropertyOptional({ type: Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataDto.prototype, "orderComplete", void 0);
__decorate([
    ApiPropertyOptional({ type: Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataDto.prototype, "headerTopNavBar", void 0);
__decorate([
    ApiPropertyOptional({ type: Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataDto.prototype, "iframeLoyalty", void 0);
__decorate([
    ApiPropertyOptional({ type: Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataDto.prototype, "metaTags", void 0);
__decorate([
    ApiPropertyOptional({ type: Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataDto.prototype, "unsubscribeMessage", void 0);
__decorate([
    ApiPropertyOptional({ type: Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataDto.prototype, "defaultTip", void 0);
__decorate([
    ApiPropertyOptional({ type: Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataDto.prototype, "socialMedia", void 0);
__decorate([
    ApiProperty({ type: Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsDefined({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataDto.prototype, "orderToTable", void 0);
__decorate([
    ApiProperty({ type: () => ReadProceedToCheckoutDto }),
    Type(() => ReadProceedToCheckoutDto),
    Expose({ groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE] }),
    ValidateNested({ always: true }),
    __metadata("design:type", ReadProceedToCheckoutDto)
], ReadWebStoreMetadataDto.prototype, "proceedToCheckout", void 0);
__decorate([
    ApiProperty({ type: Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsDefined({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataDto.prototype, "recommendedItems", void 0);
__decorate([
    ApiPropertyOptional({ type: Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataDto.prototype, "prepTime", void 0);
__decorate([
    ApiPropertyOptional({ type: Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataDto.prototype, "scheduleBlock", void 0);
__decorate([
    ApiPropertyOptional({ type: Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataDto.prototype, "menuConcepts", void 0);
__decorate([
    ApiProperty({ type: Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsDefined({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataDto.prototype, "navigationBar", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    IsString({ always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataDto.prototype, "defaultCartImage", void 0);
//# sourceMappingURL=ReadWebStoreMetadataDto.js.map